import DetailsPage from './DetailsPage';
export default DetailsPage;
